
export default "/assets/calculator-micro.5414ddf1.svg"